
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/hope-for-homes",
      function () {
        return require("private-next-pages/archive/hope-for-homes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/hope-for-homes"])
      });
    }
  